import {createEntityAdapter, EntityAdapter, EntityState, Update} from '@ngrx/entity';
import {Course} from '../models/course.model';
import {compareCourses} from '../common/sort-model';
import {createReducer, on} from '@ngrx/store';
import {CourseActions} from './action-types';
import {deepClone} from "../common/collection-utils";
import OCHSimpleChanges, {CourseRiskyProperties} from "../shared/utils/och-simple-changes";


export interface State extends EntityState<Course> {
  initialCoursesLoaded:boolean;
  activeCourseId: string;
  purchasedCourses: string[];
  pendingCoursesReordering: Update<Course>[];
}

export const adapter: EntityAdapter<Course> = createEntityAdapter<Course>({
  sortComparer: compareCourses
});

export const initialState: State = adapter.getInitialState({
  initialCoursesLoaded:false,
  activeCourseId: null,
  purchasedCourses: [],
  pendingCoursesReordering: null
});


export const coursesReducer = createReducer(
  initialState,
  on(CourseActions.loadCourseDetail, (state, { courseId }) => {
    return {...state, activeCourseId: courseId};
  }),
  on(
    CourseActions.courseLoaded,
    CourseActions.createNewCourse,
    (state,{course}) => adapter.addOne(course, state)
  ),

  on(CourseActions.updateCourse, (state,{course}) => adapter.updateOne(course, state)),

  on(CourseActions.updateCourseThumbnailSyncClone, (state, {course}) => {


    const originalCourse = course?.changes;
    const courseId = course?.id;
    const simpleChanges = OCHSimpleChanges.getInstance();
    simpleChanges.setRiskyLessonProperties(CourseRiskyProperties)

    console.log("updateCourseThumbnailSyncClone", originalCourse)

    if(!originalCourse?.thumbnail) {
      return;
    }

    // search for course with sourceCourseId === courseId

    const cloneCourses = Object.entries(state.entities)
      .filter(([id, currentCourse]) => {
      return currentCourse.sourceCourseId === courseId
    })
      .filter(([id, currentCourse]) => {

        if(currentCourse?.cloneType === "read-only") {

          if(currentCourse?.isThumbnailChanged === true) {
            return false;
          }

        }

        return true;

      })
      .map(([id, currentCourse]) => {

      const changes = simpleChanges.findChanges(deepClone(currentCourse), originalCourse);
      const courseChanges = simpleChanges.mergeChanges(changes)

      console.log("updateCourseThumbnailSyncClone map", id, courseChanges, changes, currentCourse)

        if(courseChanges['thumbnail']) {

          return {
            id,
            changes: {
              thumbnail: courseChanges['thumbnail'],
            },
          }

        } else {

          return null

        }

    })
      .filter(Boolean);

    console.log("updateCourseThumbnailSyncClone cloneCourses", cloneCourses)

    return adapter.updateMany(cloneCourses, state)

  }),

  on(CourseActions.updateCourseSyncClones, (state, {course}) => {

    const { id: courseId, changes: activeCourse} = course;

    const simpleChanges = OCHSimpleChanges.getInstance();

    // search a course with sourceCourseId === course.id

    const cloneCourseIds = Object.entries(state.entities)
      .filter(([id, course]) => {

      return course.sourceCourseId === courseId;

    })
      .filter(([id, currentCourse]) => {

        if(currentCourse?.cloneType === "read-only") {

          return false;

        }

        return true;

      })
      .map(([id, currentCourse]) => {

      const changes = simpleChanges.findChanges(deepClone(currentCourse), activeCourse);
      const courseChanges = simpleChanges.mergeChanges(changes)

      console.log("updateCourseSyncClones map", id, currentCourse, changes, courseChanges)

      return {
        id,
        changes: simpleChanges.removeReviewSystemProps(courseChanges)
      }

    });

    console.log("updateCourseSyncClones cloneCourseIds", cloneCourseIds)

    return adapter.updateMany(cloneCourseIds, state)

  }),

  on(CourseActions.deleteCourse, (state, {id}) =>  adapter.removeOne(id, state)),

  on(CourseActions.loadCourses, (state, {courses}) => {
    const newState = adapter.setAll(courses, state);
    newState.initialCoursesLoaded = true;
    return newState;
  }),

  on(CourseActions.coursePurchased, (state, { courseId }) => {
    return {
      ...state,
      purchasedCourses: (state.purchasedCourses || []).concat(courseId)
    };
  }),

  on(CourseActions.userPrivateLoaded, (state, {purchasedCourses}) => {
    return {
      ...state,
      purchasedCourses: [
        ...purchasedCourses
      ]
    };
  }),

  on(CourseActions.updateCourseSortOrder, (state, {newSortOrder}) => {
    const newSortedCourses = newSortOrder;

    const reorderCourses: Update<Course>[] = [];

    let seqNoCounter = 1;

    newSortedCourses.forEach(course => {

      if (course.seqNo != seqNoCounter) {

        const changes: Partial<Course> = {
          seqNo: seqNoCounter
        };

        reorderCourses.push({id:course?.id, changes});
      }

      seqNoCounter+=1;

    });

    return adapter.updateMany(reorderCourses, {...state, pendingCoursesReordering: reorderCourses});
  }),

  on(CourseActions.updateCourseSortOrderCompleted, state => {
    return {
      ...state,
      pendingCoursesReordering: []
    };
  }),

  on(CourseActions.coursePublished, (state, action) =>
    adapter.updateOne({
      id: action.courseId,
      changes: {
       status: 'published',
       url: action.url
      }
    }, state)),

  on(CourseActions.courseUnpublished, (state, action) =>
    adapter.updateOne({
      id: action.courseId,
      changes: {
        status: "draft"
      }
    }, state)
  ),
  on(CourseActions.resetActiveCourseId, (state, action) => {
    return {...state, activeCourseId: null};
  })


);


export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
